const oss_onboarding = {
    page_title: 'Bắt đầu sử dụng',
    title: 'Vài điều về bạn',
    description: 'Hãy cho chúng tôi biết một chút về bạn và dự án của bạn. Điều này giúp chúng tôi xây dựng sdvico tốt hơn cho mọi người.',
    email: {
        label: 'Địa chỉ email',
        description: 'Chúng tôi sẽ dùng địa chỉ này nếu cần liên hệ với bạn về tài khoản của bạn.',
        placeholder: 'email@example.com',
    },
    newsletter: 'Nhận cập nhật sản phẩm, thông báo bảo mật và nội dung được chọn lọc từ sdvico.',
    project: {
        label: 'Tôi đang dùng sdvico cho',
        personal: 'Dự án cá nhân',
        company: 'Dự án công ty',
    },
    project_name: {
        label: 'Tên dự án',
        placeholder: 'Dự án của tôi',
    },
    company_name: {
        label: 'Tên công ty',
        placeholder: 'Acme.co',
    },
    company_size: {
        label: 'Quy mô công ty của bạn là bao nhiêu?',
    },
    errors: {
        email_required: 'Địa chỉ email là bắt buộc',
        email_invalid: 'Nhập địa chỉ email hợp lệ',
        project_name_too_long: 'Tên dự án phải tối đa 200 ký tự',
    },
};
export default Object.freeze(oss_onboarding);
